import { TIPO_COMPLETO, TIPO_CRU, TIPO_INSPECAO } from './kmzAnexoAcoes';

export const KMZ_VIEW_QUERY = 'kmzView';
export const KMZ_CAMADAS_QUERY = 'kmzCamadas';

const ORDEM = [TIPO_CRU, TIPO_INSPECAO, TIPO_COMPLETO];

function ordenar(camadas) {
  const pedidos = (Array.isArray(camadas) ? camadas : [])
    .map((tipo) => String(tipo || '').trim().toUpperCase())
    .filter((tipo) => ORDEM.includes(tipo));
  return ORDEM.filter((tipo) => pedidos.includes(tipo));
}

export function getKmzView(search) {
  return new URLSearchParams(search || '').get(KMZ_VIEW_QUERY) === '1';
}

export function getKmzCamadas(search) {
  const params = new URLSearchParams(search || '');
  if (!params.has(KMZ_CAMADAS_QUERY)) return null;
  return ordenar((params.get(KMZ_CAMADAS_QUERY) || '').split(','));
}

export function camadasPadrao(itens) {
  const lista = Array.isArray(itens) ? itens : [];
  if (lista.some((item) => item.tipo === TIPO_COMPLETO)) return [TIPO_COMPLETO];
  if (lista.some((item) => item.tipo === TIPO_INSPECAO)) return [TIPO_INSPECAO];
  if (lista[0]) return [lista[0].tipo];
  return [];
}

export function resolverAtivos(itens, camadasMarcadas) {
  const lista = Array.isArray(itens) ? itens : [];
  const ativos = {};
  lista.forEach((item) => {
    ativos[item.tipo] = false;
  });
  const origem = camadasMarcadas == null ? camadasPadrao(lista) : camadasMarcadas;
  ordenar(origem).forEach((tipo) => {
    if (Object.prototype.hasOwnProperty.call(ativos, tipo)) ativos[tipo] = true;
  });
  return ativos;
}

export function syncKmzNaUrl(history, location, { aberto, camadas }) {
  if (!history || !location) return false;
  const params = new URLSearchParams(location.search || '');
  if (!aberto) {
    params.delete(KMZ_VIEW_QUERY);
    params.delete(KMZ_CAMADAS_QUERY);
  } else {
    params.set(KMZ_VIEW_QUERY, '1');
    params.set(KMZ_CAMADAS_QUERY, ordenar(camadas).join(','));
  }
  const qs = params.toString();
  const nextUrl = qs ? `${location.pathname}?${qs}` : location.pathname;
  const currentUrl = location.search ? `${location.pathname}${location.search}` : location.pathname;
  if (nextUrl === currentUrl) return false;
  history.replace(nextUrl);
  return true;
}
